import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedObject } from '../../../../../management/shared/sharedObject';
import { AuthNoticeService, AuthService, isLoggedIn, Login, User, UserLoaded } from '../../../../../../core/auth';
import { NewAuthService } from '../../../services/new-auth.service';
import { LoginWithOtpBindingModel } from '../../../models/loginWithOTPBindingModel';
import { LoginWithOtpReturnModel } from '../../../models/loginWithOtpReturnModel';
import { ApiResponseModel } from '../../../../../management/admin/models/apiResponseModel';
import { ConfirmOtpBindingModel } from '../../../models/confirmOtpBindingModel';
import { AppState } from '../../../../../../core/reducers';
import { select, Store } from '@ngrx/store';
import { RoleService } from '../../../../../management/shared/services/roleService';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { CommonService } from '../../../../../management/shared/services/common.service';
import { CodeInputComponent } from '../code-input/code-input.component';
import { tap } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-login-n',
  templateUrl: './login-n.component.html',
  styleUrls: ['./login-n.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginNComponent implements AfterViewInit {
  inputCount: number = 5;
  level: number = 0;
  istoch = false;
  isLoading: boolean = false;
  loginForm: FormGroup;
  loginWithOtpReturnModel: LoginWithOtpReturnModel;

  phonenumber: string;
  @ViewChild('mobileNumber') mobileNumberInput!: ElementRef;
  @ViewChild(CodeInputComponent) codeInputComponent!: CodeInputComponent;

  ngAfterViewInit(): void {
    // Ensure that the view is fully initialized before focusing
    setTimeout(() => {
      if (this.mobileNumberInput && this.mobileNumberInput.nativeElement)
        this.mobileNumberInput.nativeElement.focus();
    }, 0);
  }
  private unsubscribe: Subject<any>;
  constructor(private fb: FormBuilder,
    private auth: NewAuthService,
    private authNoticeService: AuthNoticeService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private roleService: RoleService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    this.store
      .pipe(
        select(isLoggedIn),
        tap(loggedIn => {
          if (loggedIn) {
            this.router.navigateByUrl('/account/dashboard');
          }
        })).subscribe();

    this.unsubscribe = new Subject();
  }

  ngOnInit() {

    this.authNoticeService.setNotice(null);
    this.loginForm = this.fb.group({
      mobileNumber: [
        "",
        Validators.compose([
          Validators.required
        ])
      ]
    });

  }



  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.loginForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;

  }

  formatPhoneNumber(event: Event): void {
    this.istoch = true;
    const input = event.target as HTMLInputElement;
    let inputValue = input.value.replace(/\D/g, ''); // حذف تمامی کاراکترهای غیر عددی

    // هندل کردن هر موقع که کاربر کاراکتر فاصله وارد کند
    if (inputValue.length > 4) {
      inputValue = inputValue.slice(0, 4) + ' ' + inputValue.slice(4);
    }
    if (inputValue.length > 8) {
      inputValue = inputValue.slice(0, 8) + ' ' + inputValue.slice(8);
    }
    // بروز رسانی مقدار input
    input.value = inputValue;
  }


  optimizePhoneNumber(value: string): string {
    if (!value) return value;
    value = value.replace(/\s+/g, '');
    if (value)
      value = this.faToEnDigits(value);
    return value;
  }

  faToEnDigits(text: string): string {
    return text.replace('۰', '0')
      .replace('۱', '1')
      .replace('۲', '2')
      .replace('۳', '3')
      .replace('۴', '4')
      .replace('۵', '5')
      .replace('۶', '6')
      .replace('۷', '7')
      .replace('۸', '8')
      .replace('۹', '9');
  }

  validationPhonenumber(value: string): boolean {
    value = this.optimizePhoneNumber(value);
    if (!value) return false;
    return Boolean(value.match(SharedObject.MobilePattern));
  }

  validationPassword(value: string): boolean {
    return Boolean(value.match(SharedObject.PasswordPattern));
  }

  loginCode: string = null;


  async requestOtpCode() {

    if (this.loginWithOtpReturnModel != null && this.loginWithOtpReturnModel.retryAfterSeconds > 0) return;
    this.phonenumber = this.optimizePhoneNumber(this.loginForm.controls['mobileNumber'].value);
    if (!this.validationPhonenumber(this.phonenumber)) return;


    this.isLoading = true;
    let model = new LoginWithOtpBindingModel();
    model.phoneNumber = this.phonenumber;

    this.recaptchaV3Service.execute(
      '6LfuKlkqAAAAABapJSxFInGjSQ_xCdYAxdDrL42u',
      'requestOtpCode',
      async (token: string) => {
        model.captcha = token;
        await this.auth.loginWithOtpCode(model).then((res: ApiResponseModel<LoginWithOtpReturnModel>) => {
          this.loginWithOtpReturnModel = res.data;
          if (res.succeed) {
            this.commonService.showToast("کد تأیید با موفقیت ارسال شد");
            this.level = 1;
            this.startTimer();
          } else {
            this.authNoticeService.setNotice(res.message, "danger");
          }
        }).catch(error => {
          this.isLoading = false;
          var err = error.error['result'];
          if (!err)
            err = 'خطای ناشناخته';
          this.authNoticeService.setNotice(err, "danger");
        }).finally(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        });
      }
    );



  }


  getCode(code: string) {
    this.loginCode = code.toString();
    if (this.loginCode.length >= 5) {
      this.confirmAndLogin();
    }
  }

  async confirmAndLogin() {
    if (!this.loginCode || this.loginCode.toString().length != 5) {
      this.authNoticeService.setNotice("کد را وارد نمائید", "danger");
      return;
    }
    this.isLoading = true;
    this.cdr.markForCheck();
    let model = new ConfirmOtpBindingModel();
    model.phoneNumber = this.phonenumber;
    model.code = this.loginCode.toString();

    this.recaptchaV3Service.execute(
      '6LfuKlkqAAAAABapJSxFInGjSQ_xCdYAxdDrL42u',
      'confirmAndLogin',
      async (token: string) => {
        model.captcha = token;
        await this.auth.confirmAndLogin(model).then((res: any) => {
          if (res) {
            const returnUser: User = new User();
            returnUser.firstName = res.firstName;
            returnUser.lastName = res.lastName;
            returnUser.isMale = res.isMale;
            returnUser.username = model.phoneNumber;
            returnUser.access_token = res.access_token;
            returnUser.refresh_token = res.refresh_token;
            returnUser.userStatus = res.userStatus;
            returnUser.role = res.role;
            this.store.dispatch(
              new Login({ authToken: returnUser.access_token })
            );
            this.store.dispatch(new UserLoaded({ user: returnUser }));
            this.roleService.getAllRoles();
            let params = this.aRoute.snapshot.queryParams;
            if (params['redirectURL']) {
              let redirectURL = params['redirectURL'] as string;
              if (redirectURL) {
                this.router.navigateByUrl(redirectURL);
              }

            } else
              this.router.navigateByUrl("/account/dashboard"); // Main page
          } else {
            this.isLoading = false;
            this.authNoticeService.setNotice("کاربر با این مشخصات یافت نشد", "danger");
          }

        }).catch(error => {

          var err = error.error['result'];
          if (!err)
            err = 'خطای ناشناخته';
          this.authNoticeService.setNotice(err, "danger");
          this.codeInputComponent.clear();
        }).finally(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        });
      }
    );




  }

  intervalId: any;
  startTimer() {
    // اگر یک تایمر قبلی وجود دارد، آن را پاک کنید
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    // شروع تایمر جدید
    this.intervalId = setInterval(() => {

      if (this.loginWithOtpReturnModel.retryAfterSeconds == 0) {
        clearInterval(this.intervalId); // وقتی تایمر به پایان می‌رسد، آن را پاک کنید
        return;
      }

      this.loginWithOtpReturnModel.retryAfterSeconds--;
      this.cdr.markForCheck();
    }, 1000);
  }

  backToFirst() {
    this.level = 0;
    this.istoch = false;
    this.isLoading = false;
    this.loginWithOtpReturnModel.retryAfterSeconds = 0;
    this.authNoticeService.setNotice('', "");
    this.cdr.markForCheck();
  }

  goLoginWithPass() {
    this.router.navigate(['auth/login/password']);
  }
}
